export function isCollapsedOrEmptyOffsets(start, end) {
  return !(typeof start === 'number' && typeof end === 'number' && start < end);
}

function textOffsetBeforeNode(rootEl, targetNode, targetOffset) {
  const range = document.createRange();
  range.selectNodeContents(rootEl);
  try {
    range.setEnd(targetNode, targetOffset);
  } catch (e) {
    return null;
  }
  return range.toString().length;
}

export function selectionToOffsets(rootEl, range) {
  if (!rootEl || !range || range.collapsed) return null;
  if (!rootEl.contains(range.startContainer) || !rootEl.contains(range.endContainer)) {
    return null;
  }
  const start = textOffsetBeforeNode(rootEl, range.startContainer, range.startOffset);
  const end = textOffsetBeforeNode(rootEl, range.endContainer, range.endOffset);
  if (start == null || end == null) return null;
  const lo = Math.min(start, end);
  const hi = Math.max(start, end);
  if (lo >= hi) return null;
  return { start: lo, end: hi };
}

export function offsetsToRange(rootEl, start, end) {
  if (!rootEl || isCollapsedOrEmptyOffsets(start, end)) return null;
  const walker = document.createTreeWalker(rootEl, NodeFilter.SHOW_TEXT, null);
  let pos = 0;
  let startNode = null;
  let startOff = 0;
  let endNode = null;
  let endOff = 0;
  let node = walker.nextNode();
  while (node) {
    const len = node.nodeValue ? node.nodeValue.length : 0;
    if (startNode == null && pos + len >= start) {
      startNode = node;
      startOff = start - pos;
    }
    if (pos + len >= end) {
      endNode = node;
      endOff = end - pos;
      break;
    }
    pos += len;
    node = walker.nextNode();
  }
  if (!startNode || !endNode) return null;
  const range = document.createRange();
  try {
    range.setStart(startNode, startOff);
    range.setEnd(endNode, endOff);
  } catch (e) {
    return null;
  }
  return range;
}

export function unwrapLnatMarks(rootEl) {
  if (!rootEl || typeof rootEl.querySelectorAll !== 'function') return;
  const marks = Array.from(rootEl.querySelectorAll('.lnat-pearson-hl, .lnat-pearson-strike')).reverse();
  marks.forEach((span) => {
    const parent = span.parentNode;
    if (!parent) return;
    while (span.firstChild) parent.insertBefore(span.firstChild, span);
    parent.removeChild(span);
    if (typeof parent.normalize === 'function') parent.normalize();
  });
}

function closestPane(node) {
  if (!node) return null;
  const el = node.nodeType === 1 ? node : node.parentElement;
  if (!el || typeof el.closest !== 'function') return null;
  return el.closest('[data-lnat-annotate-pane]');
}

export function readLnatSelection() {
  if (typeof window === 'undefined' || !window.getSelection) return null;
  const sel = window.getSelection();
  if (!sel || sel.rangeCount < 1 || sel.isCollapsed) return null;
  const range = sel.getRangeAt(0);
  if (!range || range.collapsed) return null;
  const startPane = closestPane(range.startContainer);
  const endPane = closestPane(range.endContainer);
  if (!startPane || startPane !== endPane) return null;
  const pane = startPane.getAttribute('data-lnat-annotate-pane');
  if (!pane) return null;
  const optionLabel = startPane.getAttribute('data-lnat-option-label') || undefined;
  if (pane === 'option' && !optionLabel) return null;
  const offsets = selectionToOffsets(startPane, range);
  if (!offsets) return null;
  return {
    pane,
    optionLabel,
    start: offsets.start,
    end: offsets.end,
  };
}
